module.exports = __webpack_public_path__ + "5a96f164a01eaf937d107c3113ea4030.png";